import {action, Action} from 'easy-peasy';
import {simpleCrudStoreFactory, SimpleCrudStoreModel} from '@/utils/storeFactories';

interface UserConfigured {
    id: number;
    username: string;
    email: string;
}

interface Notification {
    id: number;
    title: string;
    schedule: string;
    storyboardId: number;
    active: boolean;
    usersConfigured: UserConfigured[];
}

export interface NotificationsStoreModel extends SimpleCrudStoreModel<Notification> {
    addOrEditNotification: Action<NotificationsStoreModel, Notification>;
    editNotificationConfigure: Action<NotificationsStoreModel, [notificationId: number, notificationConfigures: UserConfigured[]]>;
    deleteNotificationConfigure: Action<NotificationsStoreModel, [notificationId: number, userId: number]>;
}

export default <NotificationsStoreModel>{
    ...simpleCrudStoreFactory(),
    addOrEditNotification: action((state, notification) => {
        const existingIndex = state.items.findIndex((n) => n.id === notification.id);

        if (existingIndex !== -1) {
            state.items.splice(existingIndex, 1);
        }

        state.items.pop();
        state.items.unshift(notification);
    }),
    editNotificationConfigure: action((state, [notificationId, notificationConfigures]) => {
        const existingIndex = state.items.findIndex((n) => n.id === notificationId);

        state.items[existingIndex].usersConfigured = notificationConfigures;
    }),
    deleteNotificationConfigure: action((state, [notificationId, userId]) => {
        const index = state.items.findIndex((n) => n.id === notificationId);

        const existingIndex = state.items[index].usersConfigured.findIndex((n) => n.id === userId);

        state.items[index].usersConfigured.splice(existingIndex, 1);
    }),
}; 